import React from "react"
import { Link } from "gatsby"
import { PhoneIcon } from "@heroicons/react/24/outline"

const ContactButton = () => {
  return (
    <div
      className="relative mr-2.5 shrink-0 rounded-full shadow-sm"
      initial="start"
      animate="end"
    >
      <Link
        to={`/form/contact`}
        className="block h-full w-full rounded-full ring-2 ring-blue-300 p-1 text-slate-400 shadow-sm transition hover:ring-blue-500 hover:bg-blue-50 hover:text-slate-700 hover:shadow-none focus:outline-none"
        aria-label="Notifications"
      >
        <PhoneIcon className="h-5 w-5 stroke-current" />
      </Link>
    </div>
  )
}

export default ContactButton
